export default {"src":"https://cdn.tanzhi.cn/_next/static/media/city-comparison.d3cf2acb.svg","height":156,"width":140,"blurWidth":0,"blurHeight":0};